import { httpClient } from '../http/httpClient'

export const createWithdraw = async (amount: number) => {
  const response = await httpClient
    .post(`withdraw`, { amount })
    .catch((error) => {
      throw error.response.data
    })
  return response.data
}
